import React, {
  memo,
  useMemo,
  useState,
  useCallback,
  useEffect,
  useContext,
} from 'react';
import { useMemoizedFn } from 'ahooks';
// import { H3 } from 'tea-component';
import { SortBy } from "tea-component/table/addons";
import TriggerViewCard from '@gp/components/TriggerViewCard';
// import SvgIcon from '@gp/components/Iconfont';
import MergeableTable from './components/MergeableTable';
// import TableForPDFDownload from './components/MergeableTable/TableForPDFDownload';
// import LineEchartCon from './components/LineEchartCon';
import BarEchartCon from './components/BarEchartCon';
import { context as Context } from '@gp/components/Context';
import { isEqual } from 'lodash-es';
import GeneralDownloadBtn from '@gp/components/GeneralDownloadBtn';
import DataTime from '@gp/components/DataTime';
import { studioOverallPeopleChartDownLoad } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import { FILE_TYPES2, FILE_TYPES_MAP } from '@gp/constants/const';
import useHeadcountsList from '@gp/pages/StudioDashboard/StudioOverall/Tabs/People/hooks/useHeadcountsList';
// import useDownloadTablePDF from '../../hook/useDownloadTablePDF';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
import CardBtn from '@/pages/globalpedia/components/CardBtn';
import useDownload, { createDownloadService } from '@gp/hooks/useDownload';
interface HeadcountsPropsType {
  loading: boolean;
  data: IStudioOverallPeopleChartResultItem;
  selectBO: string[];
  updateTime: string;
  sortParamsRef: React.MutableRefObject<SortBy> | null;
  run: any;
}

// 5Y Headcounts模块名称
const MODULE_NAME = '5Y Headcounts';

// 5Y Headcounts模块 PDF下载 需要用到的className
// const PDF_DOWNLOAD_NODE_CLASSNAME =
//   'dbg-studio-overall-people-5y-headcounts-pdf-card';

const DEFAULT_PROPS: HeadcountsPropsType = {
  loading: true,
  data: null,
  selectBO: [],
  updateTime: '',
  sortParamsRef: null,
  run: null,
};

function Headcounts(props: HeadcountsPropsType) {
  const { loading, data, selectBO, updateTime, sortParamsRef, run } = props;

  const [dataList, setDataList] = useState<orgHeadcountsDataTypes>(null);
  const [sorts, setSorts] = useState<SortBy>({
    by: '',
    order: undefined,
  });

  const { isDownloading, handleDownload } = useDownload({
    csvDownloadLogKey: 'STUDIO_OVERALL_PEOPLE_5Y_HEADCOUNTS_CSV_SUBMIT',
    excelDownloadLogKey: 'STUDIO_OVERALL_PEOPLE_5Y_HEADCOUNTS_EXCEL_SUBMIT',
    downloadService: createDownloadService(studioOverallPeopleChartDownLoad),
  });

  // 处理接口数据
  const { orgData } = useHeadcountsList({
    loading,
    responseRes: data,
  });

  /* const {
    isAllDatasResLoading,
    allDatas,
    updateAllDatas,
  } = useDownloadTablePDF(queryAll5YHeadcountsOfPeople);

  const { isDownloading, setIsDownloading, handleDownload } = useDownload({
    fileName: MODULE_NAME,
    csvDownloadLogKey: 'STUDIO_OVERALL_DETAIL_PEOPLE_5Y_HEADCOUNTS_CSV_SUBMIT',
    pdfDownloadLogKey: 'STUDIO_OVERALL_DETAIL_PEOPLE_5Y_HEADCOUNTS_PDF_SUBMIT',
    node: document.querySelector(`.${PDF_DOWNLOAD_NODE_CLASSNAME}`),
    downloadService: createDownloadService(download5YHeadcountsOfPeople),
  }); */

  // 接口返回数据
  useEffect(() => {
    if (loading) return;
    // 接口请求失败
    /* if (!orgData?.isSuccessReq) {
      setDataList(null);
      return;
    } */
    setDataList(orgData);
  }, [orgData, loading]);

  const handleSortsChange = useMemoizedFn((sorts: SortBy) => {
    setSorts(sorts);
    if (sortParamsRef?.current) sortParamsRef.current = sorts;
    run?.({
      management_team: selectBO,
      order_metric: sorts?.by,
      order: sorts?.order,
    });
  });

  const tabs = useMemo(() => {
    return [
      {
        id: 'chart-bar',
        label: <CardBtn onClick={() => {}} type="column-chart" />,
        component: <BarEchartCon />,
      },
      /* {
        id: 'chart-line',
        label: (
          <label onClick={() => {}}>
            <SvgIcon type="chart-line" className="svgicon" />
          </label>
        ),
        component: <LineEchartCon />,
      }, */
      {
        id: 'table',
        label: <CardBtn onClick={() => {}} type="sheet" />,
        component: (
          <MergeableTable
            sorts={sorts}
            onSortsChange={handleSortsChange}
          />
        ),
      },
      {
        id: 'download',
        label: (
          <GeneralDownloadBtn
            uiType="2"
            fileTypes={FILE_TYPES2}
            isLoading={isDownloading}
            onConfirm={(payload) => {
              const fileType = payload?.fileType || FILE_TYPES_MAP.CSV;
              handleDownload({
                fileType,
                file_type: Number.parseInt(fileType, 10),
                start_date: '',
                end_date: '',
                management_team: selectBO || [],
                metrics: ['5y_headcounts'], // headcount, headcount_cost, 5y_headcounts
                order_metric: sorts?.by,
                order: sorts?.order,
              });
            }}
          />
        ),
        component: null,
      },
    ];
  }, [sorts, isDownloading, selectBO, handleDownload]);

  /* const pdfTabs = useMemo(() => {
    return [
      {
        id: 'table',
        label: null,
        component: <TableForPDFDownload />,
      },
    ];
  }, []); */

  return (
    <Context.Provider
      value={{
        loading,
        dataList,
        updateTime,
      }}
    >
      <div className="dbg-studio-overall-people-5y-headcounts-card-container">
        <TriggerViewCard
          className="dbg-studio-overall-people-5y-headcounts-content"
          title={(
            <div className="dbg-studio-overall-people-flex">
              {MODULE_NAME}
              {!!updateTime && (
                <DataTime
                  className="dbg-common-data-time dbg-studio-overall-key-information-time dbg-common-data-time-left"
                  dateType="Month"
                  date={updateTime}
                />
              )}
              {/* <div className="dbg-common-data-time dbg-studio-overall-key-information-time dbg-common-data-time-left">Data Time: 2023-12</div> */}
            </div>
          )}
          loading={false}
          isNoData={false}
          tabs={tabs}
          defaultActiveId="chart-bar"
        />
        {/* <TriggerViewCard
          className="dbg-studio-overall-people-5y-headcounts-content"
          // 这个rootNodeClassName 是为了 下载PDF用的 不要删除
          rootNodeClassName={PDF_DOWNLOAD_NODE_CLASSNAME}
          title={<H3 style={{ color: '#000', fontSize: 16 }}>{MODULE_NAME}</H3>}
          loading={false}
          isNoData={false}
          tabs={pdfTabs}
          defaultActiveId="table"
        /> */}
      </div>
    </Context.Provider>
  );
}

Headcounts.defaultProps = DEFAULT_PROPS;

export default memo(Headcounts, (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
});
